function VersionControlled(obj, changeLog = []) {
  var targets = [], version = 0, savedLength, 
    hash = new Map([[obj, []]]),
    handler = {
      get: function(target, property) {
        var x = target[property];
        //console.log(['x',x,'t',target,'p',property]);
        //if (Object(x) !== x) return x;
        if (Object(x) !== x) {
          return x;
        }
        hash.set(x, hash.get(target).concat(property));
        return new Proxy(x, handler);
      },
      set: update,
      deleteProperty: update
    };

  function gotoVersion(newVersion) {
    newVersion = Math.max(0, Math.min(changeLog.length, newVersion));
    //var chg, target, path, property,
    //  val = newVersion > version ? 'newValue' : 'oldValue';
    var chg, target, path, property
      if (newVersion > version) { 
        var val='newValue';
        var chkredo=false;
      }else{
        var val='oldValue';
        var chkredo=true;
      }
    //console.log(val);
    while (version !== newVersion) {
      if (version > newVersion) {
        version--;
        chg = changeLog[version];
        chg.opt+='_undo';
      }else{
        chg = changeLog[version];
        //if (chkredo){
          chg.opt=chg.opt.split('_')[0];
        //}
      }
      path = chg.path.slice();
      property = path.pop();
      target = targets[version] || 
        (targets[version] = path.reduce ( (o, p) => o[p], obj ));
      if (chg.hasOwnProperty(val)) {
        target[property] = chg[val];
      } else {
        delete target[property];
      }
      if (version < newVersion) version++;
    }
    return true;
  }
  
  function gotoLastVersion() {
    return gotoVersion(changeLog.length);
  }
  function update(target, property, value) {
    //console.log('target')
    //console.log(target)
    //console.log(['property',property])
    //console.log('value')
    //console.log(value)
    // 進行新的資料更動前先清除復原記錄，避免分枝 by cmd
    $("#redobtn").addClass("disabled")
    $("#undobtn").removeClass("disabled")
    for (let i=changeLog.length-1; i>=0;i--){
      if (changeLog[i].opt.split('_').length == 2 && changeLog[i].opt.split('_')[1] =='undo'){
        changeLog.pop()
        targets.pop()
        //version-=1
      }else{
        break
      }
    }
    //console.log(['version',version,changeLog.length])
    gotoLastVersion(); // only last version can be modified
    var change = {path: hash.get(target).concat([property])};
    if (arguments.length > 2) change.newValue = value;
      // Some care concerning the length property of arrays:
    if (Array.isArray(target) && +property >= target.length) {
      savedLength = target.length;
    }
    if (property in target) {
      if (property === 'length' && savedLength !== undefined) {
        change.oldValue = savedLength;
        savedLength = undefined;
      } else {
        savedLength = target.length;
        change.oldValue = target[property];
      }
    }
    if (value==undefined){
      change.opt='normal';
    }else{
    if (value.length==5 && value[0]==-1){
      change.opt='delete';
    }else if (Array.isArray(value[0])){
      change.opt='block';
    }else{
      change.opt='normal';
    }
    }
    changeLog.push(change);
    targets.push(target);
    return gotoLastVersion();
  }
  this.data = new Proxy(obj, handler);
  this.getVersion = _ => version;
  this.gotoVersion = gotoVersion;
  this.gotoLastVersion = gotoLastVersion;
  this.getChangeLog = _ => changeLog;
  // apply change log
  gotoLastVersion(); 
}
export default VersionControlled;
